{
  "name": "chorenzo",
  "version": "1.9.0",
  "description": "Open-source CLI engine that automates your engineering workflow with AI-powered workspace analysis and recipe application",
  "main": "dist/main.js",
  "type": "module",
  "bin": {
    "chorenzo": "dist/main.js"
  },
  "scripts": {
    "dev": "tsx watch src/main.ts",
    "start": "tsx src/main.ts",
    "build": "tsup",
    "typecheck": "tsc --noEmit",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "lint": "eslint .",
    "lint:fix": "eslint --fix .",
    "test": "node --experimental-vm-modules --no-warnings node_modules/jest/bin/jest.js",
    "test:watch": "node --experimental-vm-modules --no-warnings node_modules/jest/bin/jest.js --watch",
    "test:coverage": "node --experimental-vm-modules --no-warnings node_modules/jest/bin/jest.js --coverage",
    "prepare": "husky"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/chorenzo-dev/engine.git"
  },
  "keywords": [
    "cli",
    "automation",
    "devtools",
    "ai",
    "typescript",
    "eslint",
    "cicd",
    "github-actions",
    "code-quality",
    "developer-experience",
    "workflow",
    "recipes",
    "engineering-automation",
    "claude-ai",
    "workspace-analysis",
    "monorepo",
    "project-setup",
    "developer-tools",
    "code-formatting",
    "linting",
    "testing-setup",
    "infrastructure-as-code",
    "configuration-management",
    "npx",
    "chorenzo"
  ],
  "author": "Chorenzo Development Team",
  "license": "Apache-2.0",
  "homepage": "https://github.com/chorenzo-dev/engine#readme",
  "bugs": {
    "url": "https://github.com/chorenzo-dev/engine/issues"
  },
  "files": [
    "dist",
    "LICENSE",
    "README.md",
    "package.json"
  ],
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "overrides": {
    "test-exclude": "^7.0.1",
    "glob": "^10.4.1"
  },
  "devDependencies": {
    "@commitlint/cli": "^19.8.1",
    "@commitlint/config-conventional": "^19.8.1",
    "@eslint/js": "^9.31.0",
    "@jest/globals": "^30.0.4",
    "@semantic-release/exec": "^7.1.0",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/github": "^11.0.4",
    "@trivago/prettier-plugin-sort-imports": "^5.2.2",
    "@types/jest": "^30.0.0",
    "@types/node": "^24.0.10",
    "@types/react": "^19.1.8",
    "@types/write-file-atomic": "^4.0.3",
    "@typescript-eslint/eslint-plugin": "^8.38.0",
    "@typescript-eslint/parser": "^8.38.0",
    "esbuild-plugin-copy": "^2.1.1",
    "eslint": "^9.31.0",
    "globals": "^16.3.0",
    "husky": "^9.1.7",
    "jest": "^30.0.4",
    "lint-staged": "^16.1.2",
    "memfs": "^4.17.2",
    "prettier": "^3.6.2",
    "semantic-release": "^24.2.7",
    "ts-jest": "^29.4.0",
    "tsup": "^8.5.0",
    "tsx": "^4.20.3",
    "typescript": "^5.8.3"
  },
  "dependencies": {
    "@anthropic-ai/claude-code": "^1.0.38",
    "commander": "^14.0.0",
    "fastest-levenshtein": "^1.0.16",
    "handlebars": "^4.7.8",
    "ink": "^6.0.1",
    "ink-select-input": "^6.2.0",
    "ink-spinner": "^5.0.0",
    "ink-text-input": "^6.0.0",
    "pino": "^9.7.0",
    "pino-pretty": "^13.0.0",
    "react": "^19.1.0",
    "simple-git": "^3.28.0",
    "write-file-atomic": "^6.0.0",
    "yaml": "^2.8.0",
    "zod": "^4.0.17"
  }
}
